export const selectIsDeleted = (state) => state?.meta?.deleted ?? false;
export const selectPending = (state) => state?.meta?.pending ?? null;

export const selectSource = (state) => state?.meta?.source ?? null;

export const selectOverlay = (state) => state?.meta?.overlay ?? null;
